import { Notification, toast } from 'components/ui'
import { showMessageError } from 'utils/storeHube/helpers'

const TICKET_ERROR_TYPES = {
    category_not_found: 'ticket_error_category_not_found',
    store_not_visible: 'ticket_error_store_not_visible',
    no_responsible: 'ticket_error_no_responsible',
    operator_not_in_teams: 'ticket_error_operator_not_in_teams',
    exception: 'ticket_error_exception',
}

const TICKET_ERROR_DEFAULTS = {
    category_not_found: 'La categoría seleccionada no fue encontrada o no está visible',
    store_not_visible: 'La tienda seleccionada no existe o no está visible',
    no_responsible: 'No se encontró un responsable asignado para la tienda',
    operator_not_in_teams: 'El operador no pertenece a los equipos de la tienda',
    exception: 'Ocurrió un error inesperado. Intente nuevamente',
}

const handleTicketError = (error, t) => {
    const data = error?.response?.data
    const errorType = data?.type

    if (errorType && TICKET_ERROR_TYPES[errorType]) {
        const translationKey = TICKET_ERROR_TYPES[errorType]
        const defaultMessage = TICKET_ERROR_DEFAULTS[errorType]
        const message = t(translationKey, { defaultValue: defaultMessage })

        toast.push(
            <Notification title={'Error'} type="danger" duration={4000}>
                <p>{message}</p>
                {data?.message && errorType !== 'exception' && (
                    <p className="text-xs text-gray-400 mt-1">{data.message}</p>
                )}
            </Notification>
        )
        return
    }

    if (data?.message) {
        showMessageError(data.message)
        return
    }

    showMessageError(error?.message || 'Error desconocido')
}

export default handleTicketError
